import React from 'react';
import { MenuItem } from './ContextMenuItem.styles';

interface IContextMenuItem {
	children: React.ReactNode;
}

export const ContextMenuItem = ({ children }: IContextMenuItem) => {
	return <MenuItem>{children}</MenuItem>;
};
